import React, { useMemo, useCallback } from 'react';
import { RightOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import MultiCascader from '../container';
import Checkbox from './Checkbox';

var noop = function noop() {};

export default /*#__PURE__*/React.memo(function (props) {
  var node = props.node,
      depth = props.depth;
  var children = node.children,
      value = node.value,
      title = node.title,
      isLeaf = node.isLeaf,
      disabled = node.disabled;

  var _MultiCascader$useCon = MultiCascader.useContainer(),
      handleCascaderChange = _MultiCascader$useCon.handleCascaderChange,
      menuPath = _MultiCascader$useCon.menuPath,
      selectLeafOnly = _MultiCascader$useCon.selectLeafOnly,
      _MultiCascader$useCon2 = _MultiCascader$useCon.renderNodeTitle,
      renderNodeTitle = _MultiCascader$useCon2 === void 0 ? noop : _MultiCascader$useCon2;

  var hasChildren = isLeaf === false || children && children.length !== 0;
  var handleClick = useCallback(function () {
    handleCascaderChange(node, depth);
  }, [node, depth]);
  var active = useMemo(function () {
    return !!menuPath.find(function (item) {
      return item.value === value;
    });
  }, [menuPath, value]);
  var cls = classnames('biz-component-multi-cascader-column-item', {
    'biz-component-multi-cascader-column-item-active': active
  });
  var checkboxVisible = selectLeafOnly && hasChildren;
  return /*#__PURE__*/React.createElement("li", {
    onClick: handleClick,
    className: cls
  }, checkboxVisible ? null : /*#__PURE__*/React.createElement(Checkbox, {
    node: node
  }), /*#__PURE__*/React.createElement("p", {
    className: "biz-component-multi-cascader-column-item-label",
    style: {
      paddingLeft: checkboxVisible ? '0px' : ''
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: disabled ? 'disabled' : ''
  }, renderNodeTitle(value) || title)), hasChildren ? /*#__PURE__*/React.createElement(RightOutlined, null) : null);
});